import { Meta } from '@/src/components/common/Meta';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MyJams from '../components/game/MyJams/MyJams';

export const ActiveEventsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t(i18nKeys.meta.activeEvents.title)} />
      <MyJams />
    </>
  );
};
